/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Structure properties of a bridge with translation
 */
export interface TranslatedStructureProperties { 
    /**
     * Key to be shown in the frontend
     */
    displayname?: string;
    /**
     * Value to be shown in the frontend for the bridge
     */
    value?: string;
    /**
     * Translation of the value
     */
    translatedValue?: string;
    /**
     * Value to differentiate from which table (structureproperty, number_properties, text_properties, categories)
     */
    fieldname?: string;
}

